import baseIsSet from "./component-library464.mjs";
import baseUnary from "./component-library433.mjs";
import nodeUtil from "./component-library434.mjs";
var nodeIsSet = nodeUtil && nodeUtil.isSet;
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
const isSet$1 = isSet;
export {
  isSet$1 as default
};
